import { isArray, isEmpty, map } from 'lodash-es';
import React from 'react';

function ProductList(props) {
	const { category, data, onAddToCategory, onRemoveProductClicked } = props;

	return (
		<div className="category-section">
			<div className="category-title-toolbar">
				<h2 className="category-title">{category.label}</h2>
				<button
					className="outline-button"
					onClick={() => onAddToCategory(category)}
				>
					Dodaj
				</button>
			</div>

			{!data || (isArray(data) && isEmpty(data)) ? (
				<EmptyState />
			) : (
				<React.Fragment>
					{map(data, (x) => (
						<div className="drink-card" key={x.id}>
							<div className="drink-info">
								<p className="drink-name">{x.name}</p>
								<p className="drink-desc">{x.description}</p>
							</div>
							<div className="drink-actions">
								<button
									className="delete-button"
									onClick={() => onRemoveProductClicked(x.id)}
								>
									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M15 15L1 1"
											stroke="#B02785"
											strokeWidth="1.5"
											strokeLinecap="round"
										/>
										<path
											d="M1 15L15 1"
											stroke="#B02785"
											strokeWidth="1.5"
											strokeLinecap="round"
										/>
									</svg>
								</button>
							</div>
						</div>
					))}
				</React.Fragment>
			)}
		</div>
	);
}

function EmptyState() {
	return (
		<p className="empty-state-desc">
			Trenutno nemate unešenih proizvoda u ovoj kategoriji
		</p>
	);
}

export default ProductList;
